import React, { ReactElement } from 'react';
import {
  Col, Row, Heading, Loader,
} from 'idsk-react-components';
import usePodporovatelList from '../hooks/usePodporovatelList';
import PodporovatelTable from './PodporovatelTable';
import './podporovatelListComponent.scss';

const PodporovatelListComponent = (): ReactElement => {
  const {
    podporovatelListPage, podporovatelStatus, podporovatelPageNumberFromUrl,
  } = usePodporovatelList();

  return (
    <section className="podporovatel-list-section">
      <Row>
        <Col>
          <Heading size="m">ZOZNAM PODPOROVATEĽOV</Heading>
        </Col>
      </Row>
      <Loader loading={podporovatelStatus.loading}>
        <PodporovatelTable
          page={podporovatelListPage}
          pageNumberFromUrl={podporovatelPageNumberFromUrl}
        />
      </Loader>
    </section>
  );
};

export default PodporovatelListComponent;
